
import { Component, Mixins, Prop } from "vue-property-decorator";
import GoogleAutocomplete from "@/common/components/google-autocomplete.vue";
import { OfficeFormDto } from "@/types/office.type";
import OfficeProfileMixin from "../../office-profiles.mixin";
import { mapState } from "vuex";
import AuthMixin from "@/common/mixins/auth.mixin";
import GoogleAddressMixin from "@/common/mixins/google-address.mixin";
import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";

@Component({
  components: {
    GoogleAutocomplete
  },
  computed: {
    ...mapState("OfficeProfile", ["infoForm"])
  }
})
export default class OfficeInformationEditComponent extends Mixins(GoogleAddressMixin, ValidatedFormMixin, OfficeProfileMixin, AuthMixin) {
  @Prop() activeTab!: number;
  
  infoForm!: OfficeFormDto;

  mounted(): void {
    if (this.selectedOffice) {
      this.$store.commit("OfficeProfile/updateField", {
        path: "infoForm",
        value: {
          officeName: this.selectedOffice.officeName,
          address1: this.selectedOffice.address1,
          address2: this.selectedOffice.address2,
          city: this.selectedOffice.city,
          state: this.selectedOffice.state,
          zipCode: this.selectedOffice.zipCode,
          website: this.selectedOffice.website,
          phone: this.selectedOffice.phone,
          officePhone: this.selectedOffice.officePhone,
          practiceId: this.selectedOffice.practiceId,
          officeId: this.selectedOffice.id,
          emailAddress: this.selectedOffice.emailAddress
        } as OfficeFormDto 
      });
    }

    if (this.infoForm.address1 && this.infoForm.city && this.infoForm.state){
      this.setAddressString(this.infoForm);
    }

    this.$validator.reset();
  }

  async submit(): Promise<void> {
    await this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.setLoading(true);

        await this.$store.dispatch("OfficeProfile/saveOffice", {
          practiceId: this.infoForm.practiceId,
          officeId: this.infoForm.officeId,
          officeName: this.infoForm.officeName,
          address1: this.infoForm.address1,
          address2: this.infoForm.address2,
          city: this.infoForm.city,
          state: this.infoForm.state,
          zipCode: this.infoForm.zipCode,
          phone: this.infoForm.phone ? this.infoForm.phone : null,
          officePhone: this.infoForm.officePhone,
          emailAddress: this.infoForm.emailAddress,
          website: this.infoForm.website
        } as OfficeFormDto);
        
        this.setLoading(false);
      }
    });
  }

  next(): void {
    this.$validator.validateAll().then((isValid: boolean) => {
      const userInfo = this.userInfo();

      if (!userInfo) {
        return;
      }

      if (isValid && userInfo.practiceId) {
        this.infoForm.practiceId = userInfo.practiceId;

        this.$emit('update:activeTab', 1);
      }
    });
  }
}
